import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { TooltipProvider } from "@profitlens/ui/tooltip";

import "./styles/index.css";
import "./i18n";

import { LoginGate } from "@/components/login-gate";
import { AppShell } from "@/layouts/app-shell";
import { AiUsagePage } from "@/pages/ai-usage-page";
import { DashboardPage } from "@/pages/dashboard-page";
import { DataPage } from "@/pages/data-page";
import { LoginPage } from "@/pages/login-page";
import { PaymentsPage } from "@/pages/payments-page";
import { TenantsPage } from "@/pages/tenants-page";
import { AdminsPage } from "@/pages/ops/admins-page";
import { AlertsPage } from "@/pages/ops/alerts-page";
import { AnnouncementsPage } from "@/pages/ops/announcements-page";
import { AuditPage } from "@/pages/ops/audit-page";
import { AiPage } from "@/pages/settings/ai-page";
import { ChannelsPage } from "@/pages/settings/channels-page";
import { PlansPage } from "@/pages/settings/plans-page";
import { SitePage } from "@/pages/settings/site-page";
import { TemplatesPage } from "@/pages/settings/templates-page";
import { WebsitePage } from "@/pages/settings/website-page";
import { queryClient } from "@/lib/query-client";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider delayDuration={200}>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/"
              element={
                <LoginGate>
                  <AppShell />
                </LoginGate>
              }
            >
              <Route index element={<DashboardPage />} />
              <Route path="tenants" element={<TenantsPage />} />
              <Route path="data" element={<DataPage />} />
              <Route path="payments" element={<PaymentsPage />} />
              <Route path="settings/site" element={<SitePage />} />
              <Route path="settings/plans" element={<PlansPage />} />
              <Route path="settings/channels" element={<ChannelsPage />} />
              <Route path="settings/ai" element={<AiPage />} />
              <Route path="settings/templates" element={<TemplatesPage />} />
              <Route path="website" element={<WebsitePage />} />
              <Route path="ai/usage" element={<AiUsagePage />} />
              <Route path="ops/announcements" element={<AnnouncementsPage />} />
              <Route path="ops/alerts" element={<AlertsPage />} />
              <Route path="ops/audit" element={<AuditPage />} />
              <Route path="ops/admins" element={<AdminsPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </StrictMode>,
);
